import { apiFetch } from './auth-service';

export interface EnrollmentWithUser {
  _id: string;
  userId: { _id: string; name: string; email: string; avatar: string };
  courseId: { _id: string; title: string; modules: Array<{ items: Array<{ _id: string }> }> };
  enrolledAt: string;
  completedItems: string[];
  completedAt: string | null;
  lastAccessedAt: string;
}

export interface EnrollmentDoc {
  _id: string;
  userId: string;
  courseId: {
    _id: string;
    title: string;
    category: string;
    level: string;
    price?: string;
    courseType?: string;
    thumbnailUrl?: string;
    modules: Array<{ items: Array<{ _id: string }> }>;
  } | string;
  enrolledAt: string;
  completedItems: string[];
  completedAt: string | null;
  lastAccessedAt: string;
}

export const getMyEnrollments = async (): Promise<EnrollmentDoc[]> => {
  const r = await apiFetch.get<{ enrollments: EnrollmentDoc[] }>('/enrollments/my');
  return r.enrollments;
};

export const getEnrollmentByCourse = async (courseId: string): Promise<EnrollmentDoc | null> => {
  const r = await apiFetch.get<{ enrollment: EnrollmentDoc | null }>(`/enrollments/${courseId}`);
  return r.enrollment;
};

export const enrollInCourse = async (courseId: string): Promise<EnrollmentDoc> => {
  const r = await apiFetch.post<{ enrollment: EnrollmentDoc }>('/enrollments', { courseId });
  return r.enrollment;
};

export const markItemComplete = async (courseId: string, itemId: string): Promise<EnrollmentDoc> => {
  const r = await apiFetch.post<{ enrollment: EnrollmentDoc }>(
    `/enrollments/${courseId}/items/${itemId}/complete`
  );
  return r.enrollment;
};

export const getCourseEnrollments = async (courseId: string): Promise<EnrollmentWithUser[]> => {
  const r = await apiFetch.get<{ enrollments: EnrollmentWithUser[] }>(
    `/enrollments/course/${courseId}`
  );
  return r.enrollments;
};
